import React from "react";
import { Controller } from "react-hook-form";
import { Form, Select, Collapse } from "antd";
import SolutionAccessDropDown from "./SolutionAccessDropDown";

const { Panel } = Collapse;
const { Option } = Select;

const SolutionAccessElement = (props) => {
  const { control, index, app_name, options, isLoading } = props;

  return (
    <Collapse defaultActiveKey={app_name} expandIconPosition="end">
      <Panel header={app_name} key={app_name}>
        <Form.Item
          labelCol={{ xl: { span: 3 }, lg: { span: 3 } }}
          labelAlign="left"
          label={
            app_name === "IntelliSight Plus" ? "User Role" : "Solution Access"
          }
        >
          <Controller
            control={control}
            name={`config.${index}.application_role_id`}
            render={({ field: { onChange, value } }) => (
              <SolutionAccessDropDown
                app_name={app_name}
                value={value}
                onChange={onChange}
                options={options}
                isLoading={isLoading}
                style={{ width: "15%" }}
              />
              // <Select
              //   placeholder={`${app_name} Solution Access`}
              //   showSearch
              //   onChange={(values) => {
              //     onChange(values);
              //   }}
              //   value={value}
              //   style={{ width: "15%" }}
              //   loading={isLoading}
              //   optionFilterProp="children"
              //   filterOption={(input, option) => {
              //     return (
              //       option.children
              //         .toLowerCase()
              //         .indexOf(input.toLowerCase()) >= 0
              //     );
              //   }}
              // >
              //   {options.map((option) => {
              //     return (
              //       <Option key={option?._id} value={option?._id}>
              //         {option?.role_name}
              //       </Option>
              //     );
              //   })}
              //   <Option value={null}>No</Option>
              // </Select>
            )}
          />
        </Form.Item>
      </Panel>
    </Collapse>
  );
};

export default SolutionAccessElement;
